/**
 * Campfire's routes, as the shell needs to refer to them.
 *
 * Exported because the app shell navigates here — from the ended hunt detail page,
 * and later from a share link. A sibling domain cannot use these (domains never
 * depend on each other), so the shell is the whole audience.
 */
export const campfirePaths = {
  huntReplay: '/replay/$huntId',
  sharedReplay: '/replay-share/$shareId',
  /** The browser landing for a natlinkedin share link: `/link?ntlkd=<code>`. */
  link: '/link',
} as const

/** The concrete location for one hunt's replay. */
export function huntReplayLocation(huntId: string): string {
  return `/replay/${encodeURIComponent(huntId)}`
}

/** The concrete location for a shared replay; the share id is the link's access key. */
export function sharedReplayLocation(shareId: string): string {
  return `/replay-share/${encodeURIComponent(shareId)}`
}
